module.exports = __webpack_public_path__ + "img/3747371.0814c022.jpg";